import { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { FleetAuthProvider } from '@/contexts/FleetAuthContext';
import { FleetProtectedRoute } from './guards';

const FleetLogin = lazy(() => import('@/pages/fleet/Login'));
const FleetDashboard = lazy(() => import('@/pages/fleet/Dashboard'));
const FleetTrips = lazy(() => import('@/pages/fleet/Trips'));
const FleetDrivers = lazy(() => import('@/pages/fleet/Drivers'));
const FleetVehicles = lazy(() => import('@/pages/fleet/Vehicles'));
const FleetDocuments = lazy(() => import('@/pages/fleet/Documents'));
const FleetInvoices = lazy(() => import('@/pages/fleet/Invoices'));
const FleetInvoicing = lazy(() => import('@/pages/fleet/Invoicing'));
const FleetUpload = lazy(() => import('@/pages/fleet/Upload'));
const FleetProfile = lazy(() => import('@/pages/fleet/Profile'));

export function FleetRoutes() {
  return (
    <FleetAuthProvider>
      <Routes>
        <Route path="login" element={<FleetLogin />} />
        <Route path="dashboard" element={<FleetProtectedRoute><FleetDashboard /></FleetProtectedRoute>} />
        <Route path="trips" element={<FleetProtectedRoute><FleetTrips /></FleetProtectedRoute>} />
        <Route path="drivers" element={<FleetProtectedRoute><FleetDrivers /></FleetProtectedRoute>} />
        <Route path="vehicles" element={<FleetProtectedRoute><FleetVehicles /></FleetProtectedRoute>} />
        <Route path="documents" element={<FleetProtectedRoute><FleetDocuments /></FleetProtectedRoute>} />
        <Route path="invoices" element={<FleetProtectedRoute><FleetInvoices /></FleetProtectedRoute>} />
        <Route path="invoicing" element={<FleetProtectedRoute><FleetInvoicing /></FleetProtectedRoute>} />
        <Route path="upload" element={<FleetProtectedRoute><FleetUpload /></FleetProtectedRoute>} />
        <Route path="profile" element={<FleetProtectedRoute><FleetProfile /></FleetProtectedRoute>} />
        <Route path="" element={<Navigate to="/fleet/login" replace />} />
      </Routes>
    </FleetAuthProvider>
  );
}
